import { QueryClient } from "@tanstack/react-query";
import { getOfflineDb, STORES } from "./idbDatabase";

/**
 * Persists TanStack Query cache to IndexedDB (survives refresh & low connectivity).
 */
export function createIdbPersister() {
  return {
    persistClient: async (client) => {
      const db = await getOfflineDb();
      await db.put(STORES.meta, {
        key: "reactQueryClient",
        value: client,
        updatedAt: new Date().toISOString(),
      });
    },
    restoreClient: async () => {
      const db = await getOfflineDb();
      const row = await db.get(STORES.meta, "reactQueryClient");
      return row?.value ?? undefined;
    },
    removeClient: async () => {
      const db = await getOfflineDb();
      await db.delete(STORES.meta, "reactQueryClient");
    },
  };
}

export function createAppQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 3 * 60 * 1000,
        gcTime: 24 * 60 * 60 * 1000,
        retry: (failureCount, error) => {
          if (!navigator.onLine) return false;
          return failureCount < 2;
        },
        refetchOnWindowFocus: true,
        networkMode: "offlineFirst",
      },
      mutations: {
        networkMode: "offlineFirst",
      },
    },
  });
}
